// Pulsing purple "your location" marker.
// Returns only the marker visual — DispensaryMap hosts it inside a
// mapboxgl.Marker element via the `markers` prop (no react-map-gl).

interface OwnLocationMarkerProps {
  title?: string
  /** Subtle emphasis for the org's currently-selected location (larger core +
   *  brighter glow). EVERY own-location marker pulses regardless of this flag —
   *  emphasis only distinguishes the active store on pages that have one. */
  emphasized?: boolean
}

export function OwnLocationMarker({ title, emphasized = false }: OwnLocationMarkerProps) {
  const size = emphasized ? 56 : 48
  const coreInset = emphasized ? 18 : 16
  const dot = emphasized ? 9 : 8
  return (
    <div style={{ position: 'relative', width: size, height: size }} title={title}>
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '2px solid rgba(139,92,246,0.5)', animation: 'cs-ping 2.5s ease-out infinite' }} />
      <div style={{ position: 'absolute', inset: 4, borderRadius: '50%', border: '1.5px solid rgba(139,92,246,0.35)' }} />
      <div style={{ position: 'absolute', inset: 10, borderRadius: '50%', border: '1.5px solid rgba(139,92,246,0.55)', background: 'rgba(139,92,246,0.08)' }} />
      <div style={{ position: 'absolute', inset: coreInset, borderRadius: '50%', background: '#8b5cf6', boxShadow: emphasized ? '0 0 16px rgba(139,92,246,0.95)' : '0 0 12px rgba(139,92,246,0.7)' }} />
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: dot, height: dot, borderRadius: '50%', background: '#ffffff' }} />
    </div>
  )
}
